import { Button } from '@kcftech/design-system';
import styled, { css } from 'styled-components';

/**
 * Rounded DSM Button
 * TODO: Decide what is primary, secondary, tertiary
 */
export const StyledButton = styled(Button)<{
    $padding?: string;
    $color?: string;
    $background?: string;
    $hoverBackground?: string;
}>`
    white-space: nowrap;
    display: flex !important;
    justify-content: center !important;
    border-radius: 5px !important;
    padding: ${({ $padding }) => `${$padding} !important`};
    color: ${({ $color }) => `${$color} !important`};
    background: ${({ $background }) => `${$background} !important`};

    ${({ $hoverBackground }) =>
        $hoverBackground
            ? css`
                  &:hover {
                      background: ${$hoverBackground} !important;
                  }
              `
            : undefined};
`;
